export default "<div style=height:46px> <div> <span class=plant-name>{{plant.name}}</span> <span class=shop>Shop {{shop.name}}</span> </div> <div style=display:inline-block> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=countsInterval ng-options=\"t.value as t.text for t in countDisplayIntervalOptions\" ng-change=countsIntervalChanged></select> </label> </div> <div style=display:inline-block;height:46px;margin-left:10px> <btn-array options=navigationUrls /> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/counts/counts.header.template.html
// module id = 618
// module chunks = 0